// src/components/pages/Movimento/profiles/saida/index.js
import { baseDefaults } from "../base/defaults";

export const saidaProfile = {
    ...baseDefaults,
    natureza: "Saida",
    parceiroVai: "remetente",
};
